import { defineMessages } from "react-intl";

const baseId = "t.components.modals.Admin.NotifyMgmt.";

export default defineMessages({
  CTABack: {
    id: baseId + "CTABack",
    defaultMessage: "Back",
  },
  titleModal: {
    id: baseId + "titleModal",
    defaultMessage: "ADD/EDIT NOTIFY",
  },
  close: {
    id: baseId + "close",
    defaultMessage: "CLOSE",
  },
  add: {
    id: baseId + "add",
    defaultMessage: "DONE",
  },
  title: {
    id: baseId + "title",
    defaultMessage: "Title notify",
  },
  text: {
    id: baseId + "text",
    defaultMessage: "body notify",
  },
  date: {
    id: baseId + "date",
    defaultMessage: "date",
  },
  roles: {
    id: baseId + "roles",
    defaultMessage: "roles notify",
  },
});
